export const TABLE_INIT = 'TABLE_INIT'
export const TABLE_SAVE = 'TABLE_SAVE'
export const TABLE_UPDATE = 'TABLE_UPDATE'
export const TABLE_SELECT_TAB = 'TABLE_SELECT_TAB'
export const TABLE_SYNC_FIELD = 'TABLE_SYNC_FIELD'
export const TABLE_UPDATE_STEREOTYPES_COLUMNS =
	'TABLE_UPDATE_STEREOTYPES_COLUMNS'
export const TABLE_UPDATE_HISTORY_COLUMNS = 'TABLE_UPDATE_HISTORY_COLUMNS'
export const TABLE_NAMING_EXECUTE = 'TABLE_NAMING_EXECUTE'
